import React from "react";
import "./styles/History.scss";
import HistoryContent from "./HistoryContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const History = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={`${t("aboutUs.history.seo.title")}`} description={`${t("aboutUs.history.seo.des")}`} path="about/history" />
      <div id="history_wrap">
        <div className="title_wrap">
          <h2>History</h2>
          <h2 className="des">{t("aboutUs.history.title")}</h2>
        </div>
        <HistoryContent />
      </div>
    </>
  );
};

export default History;
